import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { App } from "../firebase";
import Adresse from "../components/address";
import { API_URL } from "../constant";
import Popup from "../components/popup";

function BookingRecap() {
  const { id } = useParams();
  const history = useHistory();
  const [size, setSize] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [cart, setCart] = React.useState(null);

  const isAfterPay = window.location.search == "?pay=checking";
  React.useEffect(() => {
    App.auth().onAuthStateChanged((u) => {
      if (u) {
        watch(u.uid);
      }
    });
  }, []);
  const watch = (userId) => {
    // console.log("requesting...", id);
    var nId = id;
    if (id.includes("?pay=")) {
      nId = id.split("?")[0];
    }
    fetch(API_URL + "watch", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        cartId: nId,
        userId: userId,
      }),
    })
      .then((res) => res.json())
      .then(function (response) {
        // console.log(response); // This will sometime be empty
        if (response.success) {
          if (response.cart) {
            //soit paid ou cancelled
            setCart(response.cart);
          } else {
            if (response.retry) {
              setTimeout(() => {
                watch(userId);
              }, 1000);
            }
          }
        } else {
          alert("Une erreur s'est produite");
        }
      })
      .catch(function (error) {
        console.log("People we have an error!", error);
        alert("Une erreur s'est produite");
      });
  };
  function timeConvert(n) {
    var num = n;
    var hours = num / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);

    if (rhours > 0) {
      return rhours + "h " + rminutes + " min";
    } else {
      return num + " min";
    }
  }

  React.useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const BlocRDV = ({ data }) => {
    function calHeight(prestations) {
      return 300 + (prestations && 18 * prestations.length) + "px";
    }

    const hei = calHeight(data.prestations);

    const getDate = () => {
      var s = new Date(data.date).toLocaleDateString("fr-FR", {
        weekday: "short",
        day: "2-digit",
        month: "short",
      });
      s +=
        " à " +
        new Date(data.date).getHours() +
        "h" +
        (new Date(data.date).getMinutes() < 10
          ? "0" + new Date(data.date).getMinutes()
          : new Date(data.date).getMinutes());

      return s.charAt(0).toUpperCase() + s.slice(1);
    };
    function diff_minutes() {
      const dt1 = new Date();
      const dt2 = new Date(data.date);
      var diff = (dt2.getTime() - dt1.getTime()) / 1000;
      diff /= 60;
      return Math.abs(Math.round(diff));
    }

    return (
      <div className="col-75 bloc-rdv" style={{ padding: 0 }}>
        <div
          className="content-sha content-rdv"
          style={{
            justifyContent: "left",
            display: size.width > 428 ? "flex" : "inherit",
          }}
        >
          {/* <div
            className={"img-test-2"}
            style={{
              height: hei,
              backgroundImage:
                data.professionnel &&
                data.professionnel.pictures[0] &&
                `url("` + data.professionnel.pictures[0] + `")`,
            }}
          > */}
          <img
            className={"img-test-2"}
            style={{ height: hei }}
            src={data.professionnel.pictures[0]}
          />
          {/* </div> */}
          <div style={{ width: "100%", padding: 0 }} className="col-50">
            <div
              className="sub-content-rdv"
              style={{ marginLeft: size.width > 428 && 45 }}
            >
              <div
                class="vous-avez-dj-un-compte raleway-bold-eerie-black-20px"
                style={{ marginBottom: size.width > 428 && 15 }}
              >
                {data.professionnel.name}
              </div>
              <Adresse
                address={
                  data.professionnel.adresse +
                  " " +
                  data.professionnel.zipcode +
                  " " +
                  data.professionnel.city
                }
                style={{ paddingBottom: size.width > 428 && 5 }}
              />
            </div>
            {size.width > 428 && <div className="divider" />}
            {data.status === "paid" ||
            data.status === "update" ||
            data.status === "usercancelled" ? (
              <div
                className="sub-content-rdv"
                style={{
                  paddingTop: size.width <= 428 && 5,
                  marginLeft: size.width > 428 && 45,
                }}
              >
                <span class="span0 premire-prestation">
                  {data && getDate()}
                </span>
                {data.prestations.map((p) => {
                  return (
                    <p
                      class="premire-prestation"
                      style={{ paddingTop: size.width > 428 && 5 }}
                    >
                      <span class="span0">{p.name}</span>
                      <span class="helveticaneue-regular-normal dove-gray-16px">
                        {" "}
                        - {timeConvert(p.time)} - {(p.price / 100).toFixed(2)}€
                      </span>
                    </p>
                  );
                })}
                <div style={{ marginTop: 20 }}>
                  {data.price != 0 ? (
                    <Adresse
                      address={
                        "Acompte de " +
                        (data.price / 100).toFixed(2) +
                        "€ payé."
                      }
                    />
                  ) : (
                    ""
                  )}

                  {data.reste && data.reste != 0 ? (
                    <Adresse
                      address={
                        "Reste à payer " +
                        (data.reste / 100).toFixed(2) +
                        "€ sur place"
                      }
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div
                  style={{ display: size.width > 428 && "flex", marginTop: 15 }}
                >
                  {data.invoinceLink && (
                    <a href={data.invoinceLink} target="_blank">
                      <div
                        class="modifier-mon-rdv raleway-bold-eerie-black-15px"
                        style={{ marginRight: size.width > 428 && 30 }}
                      >
                        Facture
                      </div>
                    </a>
                  )}

                  {data.status === "usercancelled" ||
                  data.status === "update" ? (
                    <div
                      class=" raleway-bold-eerie-black-15px"
                      style={{ marginTop: 18 }}
                    >
                      {data.status === "usercancelled"
                        ? "Vous avez annulé ce rendez-vous"
                        : "Vous avez déjà modifié ce rendez-vous "}
                    </div>
                  ) : (
                    <>
                      {diff_minutes() > 720 && (
                        <>
                          <a
                            onClick={() => {
                              history.push({
                                pathname: "/editrdv/" + data.id,
                                state: data.professionnel,
                              });
                            }}
                          >
                            <div class="modifier-mon-rdv raleway-bold-eerie-black-15px">
                              Modifier mon RDV
                            </div>
                          </a>
                          <Popup type="promptrdvcancel" withup={data} />
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            ) : (
              <div
                className="sub-content-rdv"
                style={{
                  paddingTop: size.width <= 428 && 5,
                  marginLeft: size.width > 428 && 45,
                  paddingBottom: 40,
                }}
              >
                <Adresse address="Paiement annulé" />
              </div>
            )}
          </div>
        </div>
        <p
          style={{ marginTop: 30, fontSize: size.width <= 428 && "15px" }}
          className="helveticaneue-regular-normal-gray-20px"
        >
          {data.status !== "usercancelled" &&
            "Un SMS de rappel vous sera envoyé avant votre rendez-vous. Merci de bien vouloir arriver à l’heure."}
        </p>
      </div>
    );
  };

  return (
    <>
      <div class="row" style={{ maxWidth: 1160, margin: "60px auto" }}>
        <div
          class="col-75"
          style={{
            marginLeft: size.width <= 428 && size.width > 360 && 20,
            marginRight: size.width <= 428 && size.width > 360 && 20,
          }}
        >
          <div class="container" style={{ padding: 0 }}>
            <div class="vous-avez-dj-un-compte raleway-bold-eerie-black-20px">
              {cart && (
                <>
                  {cart.status === "paid"
                    ? "Récapitulatif de votre RDV"
                    : "Rendez-vous annulé"}
                </>
              )}
            </div>
            {cart ? (
              <>
                {cart.status === "paid" ? (
                  <Popup type="acceptpay" />
                ) : (
                  <Popup type="cancelpay" />
                )}

                <BlocRDV data={cart} />
              </>
            ) : (
              <>
                <div style={{ margin: "auto", padding: "60px 0px", width: 55 }}>
                  <div class="loader" />
                </div>
                {isAfterPay &&
                  history.location.state &&
                  history.location.state.next_action && (
                    <>
                      <p
                        style={{ textAlign: "center" }}
                        className="raleway-semi-bold-eerie-black-15px"
                      >
                        La fenêtre de paiement doit s'ouvrir, veuillez vérifié
                        que le navigateur ne bloque pas les fenêtres.
                      </p>
                      <a
                        href={history.location.state.next_action}
                        target="blank"
                      >
                        <p
                          style={{ textAlign: "center" }}
                          className="raleway-semi-bold-eerie-black-15px"
                        >
                          Cliquer ici pour ouvrir la fênetre de paiement
                          manuellement
                        </p>
                      </a>
                    </>
                  )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default BookingRecap;
